var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"0a0ac13c7d4ee80d668163139f839d4976d43127"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["customer-frontend@linkgraph"]={id:"0a0ac13c7d4ee80d668163139f839d4976d43127"};
      